import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const FALLBACK_SETTINGS = {
  rates: { min_fare: 195, rate_t1: 2.54, rate_t2: 2.19, rate_t3: 2.05, rate_t4: 2.04, crossing_fee: 150, extra_pet_fee: 40, currency: "GBP" },
  contact: {
    phone_display: "+44 7892 807912",
    phone_tel: "+447892807912",
    whatsapp: "447892807912",
    email: "pettaxilondon@gmail.com",
  },
};

let settingsPromise;
export function getSettings() {
  if (!settingsPromise) {
    settingsPromise = api
      .get("/settings")
      .then((r) => r.data)
      .catch(() => FALLBACK_SETTINGS);
  }
  return settingsPromise;
}

export function imgUrl(url, w = 900) {
  if (url && url.includes("images.unsplash.com")) {
    return `${url}${url.includes("?") ? "&" : "?"}w=${w}&q=60&auto=format`;
  }
  return url;
}

export const SITE_URL = "https://pettaxi.london";

export default API;
